import { Injectable, InjectionToken, inject } from '@angular/core';

export const USER_ID_PROVIDER = new InjectionToken<() => string | undefined>('USER_ID_PROVIDER');

@Injectable({ providedIn: 'root' })
export class UserScopedStorageService {
  private readonly userIdFn = inject(USER_ID_PROVIDER, { optional: true });

  private userKey(key: string): string {
    const userId = this.userIdFn?.() ?? '__anon__';
    return `${userId}:${key}`;
  }

  get(key: string): string | null {
    try {
      if (typeof localStorage === 'undefined') return null;
      return localStorage.getItem(this.userKey(key));
    } catch {
      return null;
    }
  }

  set(key: string, value: string): void {
    try {
      if (typeof localStorage === 'undefined') return;
      localStorage.setItem(this.userKey(key), value);
    } catch {
      // storage unavailable (private mode, quota)
    }
  }

  remove(key: string): void {
    try {
      if (typeof localStorage === 'undefined') return;
      localStorage.removeItem(this.userKey(key));
    } catch {
      // storage unavailable
    }
  }
}
